import React from "react";

const Error = () => {
  return (
    <div>
      <h1 style={{color: "red", textAlign: "center"}}>
        Ви перейшли на не існуючу сторінку!
      </h1>
    </div>
  );
};

export default Error;
